import React from 'react';
import { Label, FormGroup, Row, Col, Form, Button, FormText } from 'reactstrap';
 import SelectListComponent from "../utils/selectList";
import DatePicker from 'react-datepicker';
// import DateSelector from '../utils/dateSelector';

import 'react-datepicker/dist/react-datepicker.css';
import SubmitIcon from 'react-icons/lib/md/search';
import ResetIcon from 'react-icons/lib/md/info';

const IataFilterFormComponent = ({ filters, selectedFilterMode, filterOptions, filterValues, filterLabelKey, filterValueKey, onFilterModeValueChange, onSelectedFilterValuesChange, handleDateChange, StartFilterFlightDate, EndFilterFlightDate, onSearch, onReset }) => {
    return (
        <div className={'mb-3'}>
            <Form onSubmit={e => e.preventDefault()}>
                <Row>
                    <Col md="2">
                        <FormGroup className={"mb-0"}>
                            <Label>Start Date</Label>
                             <DatePicker className="date-picker_" showMonthDropdown={true} dropdownMode="select" showYearDropdown={true} selected={StartFilterFlightDate} onChange={(payload) => handleDateChange(payload, 'StartFilterFlightDate')}/>
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup className={"mb-0"}>
                            <Label>End Date</Label>
                             <DatePicker className="date-picker_" showMonthDropdown={true} dropdownMode="select" showYearDropdown={true} selected={EndFilterFlightDate} onChange={(payload) => handleDateChange(payload, 'EndFilterFlightDate')}/>
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup className={"mb-0"}>
                            <Label>Filter Mode</Label>
                            <SelectListComponent data={filters} valueKey='id' textField='name' selectValue={selectedFilterMode} onValueChange={onFilterModeValueChange} />
                        </FormGroup>
                    </Col>
                    <Col md="4">
                        <FormGroup className="mb-0">
                            <Label>Search Box</Label>
                            <SelectListComponent data={filterOptions} multiSelectMode={true} selectValue={filterValues} valueKey={filterLabelKey} textField={filterValueKey} onValueChange={onSelectedFilterValuesChange} />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup className={"mb-0"}>
                            <div>&nbsp;</div>
                            <Button className="mt-2 btn-avi-primary pl-4 pr-4" onClick={onSearch}>
                                <SubmitIcon color="#ffffff" size="18"/>&nbsp;Filter
                            </Button> &nbsp;
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={'12'}>
                        <FormText>
                            <a href={''} className={'text-primary-avi'} onClick={onReset}>
                                <ResetIcon color="#43a8df" size="14"/>&nbsp;Reset Filter
                            </a>
                        </FormText>

                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default IataFilterFormComponent;



// WEBPACK FOOTER //
// ./src/views/iataValidation/filter-form.js